const challenges = [
  {
    title: "Manual & Fragmented",
    description:
      "Spreadsheets, personal WhatsApp accounts, scattered payment links - no unified view of borrower interactions.",
    icon: (
      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M22.75 19.25V22.3878L14.875 14.5127V8.75V5.25V5.0995L17.1377 7.36225L18.375 6.125L14 1.75L9.625 6.125L10.8622 7.36225L13.125 5.0995V5.25V8.75V14.5127L5.25 22.3878V19.25H3.5V25.375H9.625V23.625H6.48725L14 16.1122L21.5128 23.625H18.375V25.375H24.5V19.25H22.75Z" fill="white" />
      </svg>
    ),
  },
  {
    title: "No Prioritization",
    description:
      "Agents call borrowers randomly instead of focusing on high-value, high-risk accounts first.",
    icon: (
      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip-nopriority)">
          <path d="M14 22.75H17.5V24.5H14V22.75Z" fill="white" />
          <path d="M10.5 19.25H15.75V21H10.5V19.25Z" fill="white" />
          <path d="M7 15.75H15.75V17.5H7V15.75Z" fill="white" />
          <path d="M7 12.25H17.5V14H7V12.25Z" fill="white" />
          <path d="M8.75 8.75H21V10.5H8.75V8.75Z" fill="white" />
          <path d="M7 5.25H22.75V7H7V5.25Z" fill="white" />
        </g>
        <defs>
          <clipPath id="clip-nopriority">
            <rect width="28" height="28" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
  },
  {
    title: "Compliance Exposure",
    description:
      "Regulatory penalties from excessive contact, non-compliant timing, and missing audit trails.",
    icon: (
      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip-compliance)">
          <path d="M17.5 15.75V21.4375C17.5 23.1 18.4625 24.675 20.0375 25.375L21.875 26.25L23.7125 25.375C25.2 24.675 26.25 23.1 26.25 21.4375V15.75H17.5ZM24.5 21.4375C24.5 22.4875 23.8875 23.3625 23.0125 23.8L21.875 24.325L20.7375 23.8C19.8625 23.3625 19.25 22.4 19.25 21.4375V17.5H24.5V21.4375Z" fill="white" />
          <path d="M14 17.5C12.075 17.5 10.5 15.925 10.5 14C10.5 12.075 12.075 10.5 14 10.5C15.925 10.5 17.5 12.075 17.5 14H15.75C15.75 13.0375 14.9625 12.25 14 12.25C13.0375 12.25 12.25 13.0375 12.25 14C12.25 14.9625 13.0375 15.75 14 15.75V17.5Z" fill="white" />
          <path d="M14 21.875C9.625 21.875 6.125 18.375 6.125 14C6.125 9.625 9.625 6.125 14 6.125C18.375 6.125 21.875 9.625 21.875 14H20.125C20.125 10.5875 17.4125 7.875 14 7.875C10.5875 7.875 7.875 10.5875 7.875 14C7.875 17.4125 10.5875 20.125 14 20.125V21.875Z" fill="white" />
          <path d="M14 26.25C7.2625 26.25 1.75 20.7375 1.75 14C1.75 7.2625 7.2625 1.75 14 1.75C20.7375 1.75 26.25 7.2625 26.25 14H24.5C24.5 8.225 19.775 3.5 14 3.5C8.225 3.5 3.5 8.225 3.5 14C3.5 19.775 8.225 24.5 14 24.5V26.25Z" fill="white" />
        </g>
        <defs>
          <clipPath id="clip-compliance">
            <rect width="28" height="28" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
  },
  {
    title: "Expensive Tools",
    description:
      "High per-borrower pricing and long deployment cycles restrict growth for small-to-mid lenders.",
    icon: (
      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip-expensive)">
          <path d="M26.25 5.25V3.5H23.625V1.75H21.875V3.5H21C20.035 3.5 19.25 4.28531 19.25 5.25V7C19.25 7.96469 20.035 8.75 21 8.75H24.5V10.5H19.25V12.25H21.875V14H23.625V12.25H24.5C25.465 12.25 26.25 11.4647 26.25 10.5V8.75C26.25 7.78531 25.465 7 24.5 7H21V5.25H26.25Z" fill="white" />
          <path d="M21 17.5V19.25H23.2627L20.1252 22.3877L18.1199 20.3813C17.9559 20.2172 17.7333 20.1249 17.5013 20.1249H17.5C17.268 20.1249 17.0465 20.2172 16.8824 20.3813L12.25 25.0127L13.4875 26.25L17.5009 22.2373L19.5061 24.2437C19.6702 24.4078 19.8928 24.5001 20.125 24.5001C20.357 24.5001 20.5796 24.4078 20.7436 24.2437L24.5 20.4873V22.75H26.25V17.5H21Z" fill="white" />
          <path d="M3.5 26.25H1.75V21.875C1.75 18.4976 4.49759 15.75 7.875 15.75H13.125C14.8649 15.75 16.5288 16.4939 17.6899 17.7912L16.386 18.9585C15.5565 18.0317 14.3678 17.5001 13.125 17.5001H7.875C5.46254 17.5001 3.5 19.4627 3.5 21.8751V26.25Z" fill="white" />
          <path d="M10.5 14C13.8828 14 16.625 11.2578 16.625 7.875C16.625 4.49225 13.8828 1.75 10.5 1.75C7.11725 1.75 4.375 4.49225 4.375 7.875C4.375 11.2578 7.11725 14 10.5 14ZM10.5 3.5C12.9163 3.5 14.875 5.45869 14.875 7.875C14.875 10.2913 12.9163 12.25 10.5 12.25C8.08369 12.25 6.125 10.2913 6.125 7.875C6.1278 5.45991 8.08491 3.5028 10.5 3.5Z" fill="white" />
        </g>
        <defs>
          <clipPath id="clip-expensive">
            <rect width="28" height="28" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
  },
];

export default function ChallengesSection() {
  return (
    <section className="bg-white py-24 px-5 md:px-20">
      <div className="max-w-7xl mx-auto px-0 md:px-8 flex flex-col gap-16">
        {/* Header */}
        <div className="flex flex-col gap-4 items-center justify-center">
          <div className="bg-white rounded-full border border-[#bae6fd] pt-2 pr-4 pb-2 pl-4 shadow-sm">
            <span
              className="text-[#0369a1] font-bold text-xs leading-4 uppercase"
              style={{ letterSpacing: "0.6px" }}
            >
              Challenges
            </span>
          </div>
          <h2 className="text-[#111827] text-center font-['SpaceGrotesk-Bold',_sans-serif] text-4xl md:text-5xl lg:text-6xl leading-tight font-bold max-w-4xl">
            The Collection Challenges Slowing Down Your Growth
          </h2>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {challenges.map((item) => (
            <div
              key={item.title}
              className="bg-white rounded-3xl border border-[#f3f4f6] p-8 flex flex-col gap-5 shadow-[0px_8px_30px_0px_rgba(0,0,0,0.12)]"
            >
              <div className="bg-[#0284c7] rounded-3xl flex items-center justify-center w-14 h-14 shrink-0">
                {item.icon}
              </div>
              <div className="flex flex-col gap-3">
                <h3 className="text-[#111827] font-['SpaceGrotesk-Bold',_sans-serif] text-xl leading-7 font-bold">
                  {item.title}
                </h3>
                <p className="text-[#4b5563] font-normal text-base leading-[26px]">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
